import { NgModule } from '@angular/core';

import { CmpsSdpNumberPipe } from './sdp-number.pipe';
import { CmpsSdpPercentPipe } from './sdp-percent.pipe';

@NgModule({
    declarations: [CmpsSdpNumberPipe, CmpsSdpPercentPipe],
    exports: [CmpsSdpNumberPipe, CmpsSdpPercentPipe],
    providers: [CmpsSdpNumberPipe, CmpsSdpPercentPipe],
})
export class CmpsSingleDecimalPointModule {}
